export default "__VITE_ASSET__D0XWy$qE__"